import React from "react";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import withRouter from "../../../withRouter";
import BaseListPage from "../../../base/BaseListPage";
import { InfiniteScroll, Button } from "nq-component";
import Table from "../../../components/Table";
import CardView from "../../../components/common/CardView";
import InputFactory from "../../../components/InputFactory";
import OBManagementPresenter from "./OBManagementPresenter";
import DateRangePicker from "../../../components/common/DateRangePicker";

class OBManagementPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.state = {
      objects: [],
      limit: 10,
      current: 1,
      count: 0,
    };
    this.presenter = new OBManagementPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "ob_management";
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    return objects;
  }

  handleViewObject(object){
    this.navigateTo(`/form/ob_requests/${object.id}`, {isViewMode: true});
  }

  handleApprove(data){
    this.presenter.handleStatusChange(data, "Approved");
  }

  handleDisapprove(data){
    this.presenter.handleStatusChange(data, "Disapproved");
  }


  onChangeFilter(type, value, field) {
    const where = { ...this.state.filters };

    switch (type) {
      case "Pointer":
        if (Object.keys(value).length > 0) {
          where[field] = { id: value.id };
        } else {
          delete where[field]; // Remove filter if no value
        }
        break;
      default:
        if (value) {
          where[field] =
            field === "status"
              ? value
              : { $regex: value, $options: "i" };
        } else {
          delete where[field]; // Remove filter if no value
        }
    }
    this.setState({ filters: where }, () => {
      this.filterSubmit(this.state.filters);
    });
  }

  render() {
    const { objects, loading, count, limit, current } = this.state;

    console.log("OBJECTSS", objects);

    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;

    const includeLabel = Object.keys(schema.fields).filter(
      (fields) =>
        fields !== "employee" &&
        fields !== "createdAt" &&
        fields !== "dateApproved" &&
        fields !== "status"
    );

    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll className="h-100" loadMore={this.loadMore.bind(this)}>
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Finance {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    OB Management
                  </span>
                </p>
              </div>

              <CardView style={{ borderRadius: 0}}>
                <div className="row">
                  <div className="col-md-6 d-flex flex-column">
                    <label style={{ marginBottom: "0.5rem", fontSize: "0.9rem", fontWeight: 500 }}>
                      Filter by Date Requested:
                    </label>
                    <DateRangePicker
                      width="100%"
                      fields={["createdAt", "dateApproved", ""]}
                      onFilter={(filterObj) => {
                        try {
                          const update = new Date(filterObj.dateApproved.$lte);
                          update.setDate(update.getDate() + 1);
                          const formattedDate = update
                            .toISOString()
                            .split("T")[0];
                          const filterStartDate = {
                            createdAt: {
                              $lte: formattedDate,
                              $gte: filterObj.createdAt.$gte,
                            },
                          };
                          this.searchSubmit(filterStartDate);
                          this.setState({ filters: filterStartDate });
                        } catch (e) {
                          this.searchSubmit({});
                          this.setState({ filters: {} });
                        }
                      }}
                    />
                  </div>
                  <div className="col-md-6 d-flex flex-column">
                    <label style={{ marginBottom: "0.5rem", fontSize: "0.9rem", fontWeight: 500 }}>
                      Filter by OB Dates:
                    </label>
                    <DateRangePicker
                      width="100%"
                      isArray={true}
                      fields={["obDates", ""]}
                      onFilter={(filterObj) => {
                        this.searchSubmit(filterObj);
                      }}
                    />
                  </div>
                  <div className="col-12">
                    <hr className="mt-3 mb-0" />
                  </div>
                  {Object.keys(schema.filters || {})
                    .map((field) => {
                      let { type, ...options } = schema.filters[field];
                      return (
                        <div key={field} className="col-md-6 d-flex flex-column mt-2">
                          <InputFactory
                            type={type}
                            field={field}
                            where={{}}
                            onChange={this.onChangeFilter.bind(this, type)}
                            {...options}
                          />
                        </div>
                      );
                    })}
                </div>
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center  justify-content-center">
                    <h4 className="text-primary">OB Management</h4>
                    <div
                      className="d-flex gap-2"
                      style={{ marginLeft: "auto" }}
                    >
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                viewPayroll={this.handleViewObject.bind(this)}
                stepIncrement={this.handleApprove.bind(this)}
                separateEmployee={this.handleDisapprove.bind(this)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-three-dots-vertical" />,
                    actionType: "OB Management List",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Object":
                      case "Array":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At", ...includeLabel]
                )}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(OBManagementPage);
